import { render } from "./GerenciartimesView.vue?vue&type=template&id=2b56e800&scoped=true"
import script from "./GerenciartimesView.vue?vue&type=script&lang=js"
export * from "./GerenciartimesView.vue?vue&type=script&lang=js"

import "./GerenciartimesView.vue?vue&type=style&index=0&id=2b56e800&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b56e800"]])

export default __exports__